import React, { useEffect, useState } from 'react'
import "../css/WorkProcess.css"
import * as imagesdata from '../imagesdata'
import { MainTitle } from '../components/MainTitle'
import { motion } from 'framer-motion';
const WorkProcess = () => {
    const [fontSize, setFontSize] = useState(0);
    const [pageWidth, setPageWidth] = useState(window.innerWidth)
    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            const newFontSize = Math.max(15, Math.min(25, (width / 25)));
            setFontSize(newFontSize);
            setPageWidth(width)
        };

        window.addEventListener("resize", handleResize);
        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const processData = [
        {
            id: 1,
            side: "left",
            title: "Sipariş ve İhtiyaç Analizi",
            description: `Üretim sürecimizin ilk adımı olarak, bizimle iletişime geçerek ihtiyacınızı ve taleplerinizi belirtiyorsunuz. 
            Trafik yönetimi ile ilgili spesifik gereksinimlerinizi dinleyerek, projeniz için en uygun çözümü sunabilmek adına detaylı 
            bir analiz gerçekleştiriyoruz. Kullanılacak sensörlerden, sistemin entegrasyon sürecine kadar tüm ayrıntıları netleştiriyoruz.`,
            class: "work-process-first",
            image: imagesdata.WorkOrder
        },
        {
            id: 2,
            side: "right",
            title: "Teknik Çizim ve Planlama",
            description: `Sipariş detayları kesinleştikten sonra, proje gereksinimlerine uygun teknik çizimler ve planlamalar yapıyoruz. 
            Elektronik bileşenlerin yerleşimi, yazılım geliştirme aşamaları ve üretim takvimi gibi kritik unsurlar bu aşamada belirleniyor. 
            Planlama sürecimiz, projenin her aşamasının titizlikle yürütülmesini sağlıyor.`,
            class: "",
            image: imagesdata.WorkPlan
        },
        {
            id: 3,
            side: "left",
            title: "Bileşen Temini ve Kalite Kontrol",
            description: `Üretim için gerekli olan tüm elektronik ve mekanik bileşenleri tedarik ediyor, her bir parçanın kalite 
            standartlarına uygun olup olmadığını titizlikle kontrol ediyoruz. Kullanılacak malzemelerin dayanıklılığı ve uzun ömürlü 
            olması bizim için büyük önem taşıyor, bu nedenle her bileşeni detaylı bir şekilde test ediyoruz.`,
            class: "",
            image: imagesdata.WorkSupply
        },
        {
            id: 4,
            side: "right",
            title: "Montaj ve Entegrasyon",
            description: `Onaylanan teknik plana uygun olarak üretime geçiyoruz. Elektronik devreler, sensörler ve kontrol üniteleri 
            uzman ekibimiz tarafından birleştirilerek sistemin temel yapısı oluşturuluyor. Yapay zeka destekli trafik sinyalizasyon 
            sistemimizin tüm bileşenleri birbirleriyle uyumlu bir şekilde entegre edilerek çalışır hale getiriliyor.`,
            class: "",
            image: imagesdata.WorkPAssembly
        },
        {
            id: 5,
            side: "left",
            title: "Yazılım Geliştirme ve Test Aşaması",
            description: `Sistemimizin çalışmasını sağlayan yapay zeka ve yönetim yazılımı bu aşamada programlanıyor. Algoritmaların 
            doğruluğu, veri işleme hızı ve sistemin genel performansı detaylı testlerden geçiriliyor. Sensörlerin doğru tespit yapıp 
            yapmadığı, ışık sürelerinin dinamik olarak değişip değişmediği gibi kritik kontroller gerçekleştiriliyor.`,
            class: "",
            image: imagesdata.WorkPSoftwareDevelopment
        },
        {
            id: 6,
            side: "right",
            title: "Son Kontroller ve Kalite Güvencesi",
            description: `Üretimi tamamlanan sistemlerimiz, farklı senaryolara göre detaylı testlerden geçirilerek her türlü trafik 
            ortamına uyum sağladığından emin olunuyor. Güvenlik, dayanıklılık ve verimlilik açısından en yüksek standartlara ulaşana 
            kadar sistemimiz defalarca test ediliyor. Böylece, her müşterimize en güvenilir ve kaliteli çözümü sunabiliyoruz.`,
            class: "",
            image: imagesdata.WorkPFinalControl
        },
        {
            id: 7,
            side: "left",
            title: "Kurulum ve Entegrasyon Desteği",
            description: `Testleri başarıyla tamamlanan ürünler, müşterilerimizin belirlediği lokasyonlara gönderiliyor ve kurulum 
            sürecine geçiliyor. Uzman ekiplerimiz, sistemin en iyi şekilde çalışabilmesi için gerekli tüm entegrasyon işlemlerini 
            gerçekleştirerek size tam fonksiyonel bir çözüm sunuyor. Ayrıca, kullanım hakkında detaylı bilgilendirme yaparak sürecin 
            sorunsuz ilerlemesini sağlıyoruz.`,
            class: "",
            image: imagesdata.WorkPIntegrationSupport
        },
        {
            id: 8,
            side: "right",
            title: "Destek ve Bakım Hizmetleri",
            description: `Sistem kurulduktan sonra da müşteri memnuniyetini ön planda tutarak destek hizmetlerimizi sürdürüyoruz. 
            Gerekli güncellemeleri sağlıyor, teknik destek sunuyor ve sistemin sürekli olarak optimum performansta çalışmasını garanti 
            altına alıyoruz. Trafik yönetiminizin her zaman en iyi seviyede kalması için yanınızdayız.`,
            class: "work-process-last",
            image: imagesdata.WorkPMaintenanceService
        }
    ];

    return (
        <div>
            <MainTitle headerImage={imagesdata.HeaderAboutUs} />
            <div className='main-text-bold-header' style={{ fontSize: `${fontSize - 2}px` }}>
                <h1>
                    Üretim <span className='main-title-dark-text-outline'>Süreçlerimiz</span>
                </h1>
            </div>
            <div className='main-text-header'>
                <h4>
                    Siparişinizi verdikten sonra, yapay zeka destekli trafik sinyalizasyon sisteminizin üretim süreci,
                    alanında uzman ekibimiz tarafından titizlikle yürütülmektedir. Her aşamada en son teknoloji,
                    kaliteli malzemeler ve hassas mühendislik uygulamaları kullanılarak, sisteminizin en yüksek performansla
                    çalışması sağlanır. Aşağıda, bu sürecin nasıl ilerlediğini adım adım inceleyebilirsiniz.
                </h4>
            </div>
            <div class="work-process-timeline-container">

                {processData.map((process, index) => (

                    <div className={`work-process-timeline-event ${process.side === "right" ? "work-process-right-side" : ""}`} key={process.id}>
                        <motion.div className="work-process-blank-box"
                            key={index}
                            initial={{ opacity: 0, x: (pageWidth < 640 ? -100 : (process.side == "right" ? -100 : 100)) }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true, amount: 0.2 }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}>
                            <img src={process.image} />
                        </motion.div>
                        <div className={`work-process-timeline-date ${process.class}`}>
                            <span></span>
                        </div>
                        <motion.div className="work-process-timeline-details"
                            key={index}
                            initial={{ opacity: 0, x: (pageWidth < 640 ? -100 : (process.side == "left" ? -100 : 100)) }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true, amount: 0.2 }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                        >
                            <h2>{process.title}</h2>
                            <p>{process.description}</p>
                        </motion.div>
                    </div>
                ))}

            </div>
        </div >
    )
}

export default WorkProcess